/* eslint-disable */
export default {
  cancel: '取消',
  reply: '回覆',
  onMyWay: '在路上',
  customMessage: '自訂訊息',
  callMeBackIn: '請於以下時間過後回電：',
  willCallYouBackIn: '將於以下時間過後回電：',
  min: '分鐘',
  hours: '時',
  days: '天',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
